// Links inside CMS rich text. Strapi content links to the staging host
// (https://web.stage.dharmayana.in/learn-more/…), a noindexed site, and to the
// retired /learn-more paths. Rewrite them to relative production paths as the
// page renders, so a stray CMS link never sends visitors or crawlers to stage.
const OWN_HOSTS = /^https?:\/\/(?:www\.|web\.stage\.|web\.)?dharmayana\.in(?=\/|$)/i;

export const contentHref = (url?: string): string => {
    if (!url) return '';
    let href = url.trim();
    if (OWN_HOSTS.test(href)) href = href.replace(OWN_HOSTS, '') || '/';
    // /learn-more/<slug> is the retired article path; /learn-more-web is current.
    href = href.replace(/^\/learn-more(?=\/|$)(?!-)/, '/learn-more-web');
    return href;
};
